import { supabase } from "@/lib/supabase";
import type { Session, User } from "@supabase/supabase-js";
import { useCallback, useEffect, useState } from "react";

interface AuthState {
	user: User | null;
	session: Session | null;
	loading: boolean;
}

export function useAuth() {
	const [state, setState] = useState<AuthState>({
		user: null,
		session: null,
		loading: true,
	});

	useEffect(() => {
		supabase.auth.getSession().then(({ data: { session } }) => {
			setState({ user: session?.user ?? null, session, loading: false });
		});

		const {
			data: { subscription },
		} = supabase.auth.onAuthStateChange((_event, session) => {
			setState({ user: session?.user ?? null, session, loading: false });
		});

		return () => subscription.unsubscribe();
	}, []);

	const signIn = useCallback(async (email: string, password: string) => {
		const { error } = await supabase.auth.signInWithPassword({ email, password });
		if (error) throw error;
	}, []);

	const signUp = useCallback(async (email: string, password: string) => {
		const { error } = await supabase.auth.signUp({ email, password });
		if (error) throw error;
	}, []);

	const signOut = useCallback(async () => {
		const { error } = await supabase.auth.signOut();
		if (error) throw error;
	}, []);

	return { ...state, signIn, signUp, signOut };
}
